// import HeroSection from "./HeroSection";
// import Banner from "../../Assets/Images/blog_banner.png";

// import blog1 from "../../Assets/Images/blog1.png";
// import blog3 from "../../Assets/Images/blog3.png";
// import blog4 from "../../Assets/Images/blog4.png";
// import blog5 from "../../Assets/Images/blog5.png";
// import blog2 from "../../Assets/Images/blog2.png";
// import blog6 from "../../Assets/Images/blog6.png";

// const blogData = [
//     {
//         img: blog1,
//         title: 'Top Event Planning Trends in 2025 You Need to Know',

//     },
//     {
//         img: blog2,
//         title: 'How to Choose the Right Event Management Company for You?',

//     },
//     {
//         img: blog3,
//         title: 'Tips for Planning a Product Launch Event That Maximizes Sales',

//     },
//     {
//         img: blog4,
//         title: 'How to Organize a Gala Dinner That Leaves a Lasting Impression?',

//     },
//     {
//         img: blog5,
//         title: 'How to Plan a Medical Conference or Healthcare Event',

//     },
//     {
//         img: blog6,
//         title: 'Best Event Management Company in Mumbai',

//     },
// ];

// function BlogCards() {
//     return (
//         <section className="blog pt-0">
//             <HeroSection image={Banner} pageTitle="Blogs" />
//             <section className="d-flex flex-column justify-content-center align-items-center text-center">
//                 <div className="container">
//                     <h2>Our Exclusive Blogs</h2>
//                 </div>
//             </section>
//             <div className='blog-cards'>
//                 <div className="container-fluid">
//                     <div className="row g-5">
//                         {blogData.map((blog, index) => (
//                             <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
//                                 <a href="/blog" className="text-decoration-none ">
//                                     <div className="card h-100 border-0 rounded-0">
//                                         <img src={blog.img} className="card-img-top" alt={blog.title}  />
//                                         <div className="card-body ">
//                                             <p className="card-text lh-base text-white">{blog.title}</p>
//                                         </div>
//                                     </div>
//                                 </a>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }
// export default BlogCards;

import { useEffect, useState } from "react";
import axios from "../../axios"; // Adjust path as needed
import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/blog_banner.png";
import { Link } from "react-router-dom";

function BlogCards() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get("/blogs") // Assuming this endpoint returns a list of blogs
      .then((res) => {
        setBlogs(res.data);
      })
      .catch(() => {
        alert("Failed to load blogs");
      });
  }, []);

  return (
    <section className="blog pt-0">
      <HeroSection image={Banner} pageTitle="Blogs" />
      <section className="d-flex flex-column justify-content-center align-items-center text-center">
        <div className="container">
          <h2>Our Exclusive Blogs</h2>
        </div>
      </section>
      <div className="blog-cards">
        <div className="container-fluid">
          <div className="row g-5">
            {blogs.map((blog, index) => (
              <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                <Link to={`/blog/${blog.id}`} className="text-decoration-none">
                  <div className="card h-100 border-0 rounded-0">
                    <img
                      src={blog.image_url}
                      className="card-img-top"
                      alt={blog.title}
                    />
                    <div className="card-body">
                      <p className="card-text lh-base text-white">
                        {blog.title}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogCards;
